import { Provider } from '@angular/core';

import {
  STORAGE_ACCOUNT_SWITCH_CLEANUP_KEYS,
  STORAGE_EXCEPTIONAL_KEY_REGEX,
  STORAGE_LOGOUT_CLEANUP_KEYS,
  STORAGE_PREFIX,
  StorageService
} from './storage.service';

/**
 * Provides a new instance of StorageService including InjectionToken configuration for the current scope.
 * The configuration consists of
 *  - A storage key prefix, which will be added to each storage key used within the current injection scope (required).
 *  - If storage keys of current scope should be cleaned up on logout - apply either a list of keys or true for all (optional).
 *  - Same for account switch (optional).
 *  - A regex which could be used for excluding certain keys from being cleaned up (optional).
 */
export function provideStorageWithConfig(
  prefix: string,
  cleanupKeysOnLogout?: string[] | true,
  cleanupKeysOnAccountSwitch?: string[] | true,
  exceptionalKeyPattern?: RegExp
): Provider[] {
  return [
    StorageService,
    {
      provide: STORAGE_PREFIX,
      useValue: prefix
    },
    {
      provide: STORAGE_LOGOUT_CLEANUP_KEYS,
      useValue: cleanupKeysOnLogout
    },
    {
      provide: STORAGE_ACCOUNT_SWITCH_CLEANUP_KEYS,
      useValue: cleanupKeysOnAccountSwitch
    },
    {
      provide: STORAGE_EXCEPTIONAL_KEY_REGEX,
      useValue: exceptionalKeyPattern
    }
  ];
}
